import React from 'react'
import styled from 'styled-components'
import { graphql, compose } from 'react-apollo'
import CacheUtil from '../../common/utils/CacheUtil'
import DocumentBucketAutocomplete from './../DocumentBucketAutocomplete'
import autocompleteData from './../helpers/DocumentBucketAutocomplete'
import LoadingButton from '../../common/LoadingButton'
import UpsertDocumentBucket from './../queries/UpsertDocumentBucket'
import DestroyDocumentFiles from './../queries/DestroyDocumentFiles'
import DocumentsQuery from './../queries/DocumentsQuery'
import FadeInUpWrapper from '../../common/FadeInUpWrapper'
import WithLoan from '../../shared/WithLoan'

const Container = styled(FadeInUpWrapper)`
  width: 60%;
  height: 100%;
  overflow-y: auto;
  background: white;
  box-shadow: 0 4px 10px -2px rgba(0,0,0,0.3);
`
const Header = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #75AFB6;
  padding: 20px;
`
const Title = styled.div`
  grid-column-start: 2;
  grid-column-end: 2;
  color: white;
  align-self: center;
  justify-self: center;
  font-size: 12pt;
`
const Close = styled.span`
  color: white;
  grid-column-start: 3;
  grid-column-end: 3;
  cursor: pointer;
  justify-self: end;
  align-self: center;
  font-weight: bold;
  font-size: 11pt;
`
const Form = styled.section`
  padding: 20px;
`
const InputContainer = styled.div`
  padding: 10px 0;
`
const TextArea = styled.textarea`
  width: 95%;
  font-size: 11pt;
  resize: vertical;
`
const Label = styled.label`
  font-size: 11pt;
`
const RadioLabel = styled.label`
  font-size: 11pt;
  display: flex;
  align-items: center;
  margin: 0 10px;
`
const RadioInput = styled.input`
  margin: 5px 10px 5px 0px !important;
`
const RadioButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const SaveBucket = styled(LoadingButton)``
const Files = styled.div`
  padding: 10px;
`
const FilesContainer = styled.div`
  height: 165px;
  overflow-y: auto;
`

const FileCol = styled.div`
  width: 250px;
  i {
    margin-right: 10px;
  }
`
const FileHead = styled.div`
  display: flex;
  justify-items: start;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  ${FileCol} {
    font-weight: bold;
  }
`
const FileBody = styled.div`
  display: flex;
  justify-items: start;
  margin-bottom: 10px;
`

const FilesTitle = styled.h3`
  margin-bottom: 10px;
  margin-top: 10px;
`

const Link = styled.a`
  color: #56565a;
  cursor: pointer;
  text-overflow: ellipsis;
  &:hover {
    color: #56565a;
  }
`

class DocumentBucketModal extends React.Component {
  constructor(props) {
    super(props)
    const { document } = props
    this.financialCategory = 'business_financial_and_underwriting'
    const {
      title = '',
      adminOnly = false,
      description = '',
      instructions,
      category = props.category,
      esignable = false,
      phase
    } = document
    this.state = {
      title,
      adminOnly: Boolean(adminOnly),
      description: description ? description : instructions,
      category,
      entityType: null,
      esignable,
      isLoading: false,
      phase: phase || 'main',
      filesToDelete: [],
      currentEntity: null,
      originalEntity: null
    }
  }
  componentWillMount() {
    const {
      entityType,
      props: {
        entityId
      }
    } = this

    this.setCurrentEntity(entityType, entityId)
    this.setOriginalEntity(entityType, entityId)
    this.setState({ entityType })
  }
  get entityType() {
    const {
      _isAffiliate,
      _isCorporateGuarantor,
      props: {
        entity,
        resourceType
      }
    } = this

    return _isAffiliate(entity) || _isCorporateGuarantor(entity) ? 'Business' : resourceType
  }
  _storeEntities = () => {
    const { loan, guarantors } = this.props
    const { businesses } = loan
    const oc = businesses.find(({ borrowerType }) => borrowerType == 'oc')
    const epc = businesses.find(({ borrowerType }) => borrowerType == 'epc')
    const { corporateGuarantors } = oc
    const baseEntities = [oc].concat(guarantors, corporateGuarantors)
    if (epc) baseEntities.concat([epc])

    return baseEntities
  }
  _findEntity = (type, id) => (
    this._storeEntities().find(({ rid, __typename }) => rid === Number(id) && __typename === type)
  )
  _isAffiliate = entity => {
    if (entity.__typename === 'Guarantor') {
      return false
    }
    return entity.__typename === 'Business' && entity.borrowerType === 'affiliate'
  }
  _isCorporateGuarantor = entity => {
    if (entity.__typename === 'Guarantor') {
      return false
    }
    return entity.__typename === 'Business' && entity.borrowerType === 'corporate_guarantor'
  }
  setCurrentEntity = (type, id) => {
    const currentEntity = this._findEntity(type, id)

    this.setState({ currentEntity })
  }
  setOriginalEntity = (type, id) => {
    const originalEntity = this._findEntity(type, id)

    this.setState({ originalEntity })
  }
  _isDisabled = () => {
    const { newBucket, document } = this.props
    const { custom } = document

    return !newBucket && !custom
  }
  get _isMultiproduct() {
    const { multiproductFlow } = this.props.loan

    return multiproductFlow
  }
  onNameSelect = (value) => {
    this.setState({
      title: value,
      category: autocompleteData[value]
    })
  }
  onFileCheck = ({ target: { checked }}, filename) => {
    const { filesToDelete } = this.state

    if (checked) {
      this.setState({
        filesToDelete: filesToDelete.concat(filename)
      })
    } else {
      const copy = filesToDelete.slice()
      const idx = copy.findIndex(f => f.name === filename)

      if (idx > -1) {
        copy.splice(idx, 1)
        this.setState({
          filesToDelete: copy
        })
      }
    }
  }
  onSave = async () => {
    const {
      upsertDocumentBucket,
      destroyDocumentFiles,
      toggleModal,
      newBucket,
      loanId,
      flashSuccessNotification,
      document,
      resetClientStore
    } = this.props
    const { rid } = document
    const { title, adminOnly, description, category, filesToDelete, esignable, phase, currentEntity, originalEntity, entityType, isLoading } = this.state
    if (isLoading) {
      return
    }
    try {
      await this.setState({ isLoading: true })
      await upsertDocumentBucket({
        variables: {
          input: {
            documentId: !newBucket ? rid : null,
            documentFields: {
              entityType,
              entityId: currentEntity.rid,
              name: title,
              adminOnly,
              description: description ? description.substr(0, 255) : null,
              category,
              esignable,
              phase
            }
          }
        },
        update: (store, { data: { upsertDocumentBucket: { document } } }) => {
          const data = store.readQuery({ query: DocumentsQuery, variables: { rid: loanId } })
          let entity = CacheUtil.findEntityById(data.loan, currentEntity.rid, currentEntity.__typename)
          let original = CacheUtil.findEntityById(data.loan, originalEntity.rid, originalEntity.__typename)
          if (this._isAffiliate(currentEntity)) {
            entity = CacheUtil.findAffiliateEntityById(data.loan, currentEntity.rid)
          }
          if (this._isAffiliate(originalEntity)) {
            original = CacheUtil.findAffiliateEntityById(data.loan, originalEntity.rid)
          }
          // update store of entities
          if (newBucket || originalEntity !== currentEntity) {
            entity.documents = entity.documents.concat(document)
          }
          if (originalEntity !== currentEntity) {
            original.documents = original.documents.filter(({ rid }) => rid !== document.rid)
          }
          store.writeQuery({ query: DocumentsQuery, variables: { rid: loanId }, data })
        }
      })
      if (filesToDelete.length > 0) {
        await destroyDocumentFiles({
          variables: {
            input: {
              filenames: filesToDelete,
              documentId: rid
            }
          }
        })
      }
      if (!newBucket) {
        flashSuccessNotification()
      } else {
        if (resetClientStore) {
          resetClientStore()
        }
      }
      toggleModal()
    } catch (err) {
      console.log(err)
    }
  }
  renderKeyOptions = options => {
    return Object.keys(options).map(cat => {
      return <option key={cat} value={cat}>{options[cat]}</option>
    })
  }
  fileUrl = name => {
    const { document: doc } = this.props
    const { fileUrls  } = doc
    const { link } = fileUrls.find(({ filename }) => filename === name)
    return link
  }
  renderTableFiles = () => {
    const { customerService, bankAdmin, document: doc, getMomentDate } = this.props
    const { files = [], bankEditable  } = doc
    let { referenceFiles } = doc
    referenceFiles = JSON.parse(referenceFiles)
    const hasReferences = referenceFiles.length > 0
    const areFilesDeletable = customerService || (bankAdmin && bankEditable)

    return (
      <Files>
        <FileHead>
          {hasReferences && (
            <FileCol>
              Reference Date
            </FileCol>
          )}
          <FileCol>File Name</FileCol>
          {areFilesDeletable && (
            <FileCol><b>Delete File?</b></FileCol>
          )}
        </FileHead>
        <FilesContainer>
          {files.map(({ name, referenceDate, trimmedFilename }, i) => (
            <FileBody key={`file-${name}`}>
              {hasReferences && (
                <FileCol>
                  {getMomentDate(referenceDate).format('MMMM YYYY')}
                </FileCol>
              )}
              <FileCol>
                <i className="fa fa-file-text-o" />
                <Link
                  href={this.fileUrl(name)}
                  title={name}
                  target='_blank'
                  id={`file_link_${name}`}
                >
                  {trimmedFilename}
                </Link>
              </FileCol>
              {areFilesDeletable &&(
                <FileCol>
                  <input id={`delete_file_checkbox_${i}`}
                    onChange={e => this.onFileCheck(e, name)}
                    type="checkbox"
                  />
                </FileCol>
              )}
            </FileBody>
          ))}
        </FilesContainer>
      </Files>
    )
  }
  renderFiles = () => {
    const { document: doc } = this.props
    const { files = [] } = doc

    if (files.length > 0) {
      return (
        <>
          <FilesTitle>
            {`Uploaded Files (${files.length} Files)`}
            <br />
            {files.length > 6 && <small>scroll down to see more</small>}
          </FilesTitle>
          {this.renderTableFiles()}
        </>
      )
    }
  }

  getSelectType = ({ value, children, isBusiness, isGuarantor }) => {
    const { phase } = this.state
    const isFinancialCategory = value === this.financialCategory && isBusiness
    const showPhase = (isFinancialCategory || isGuarantor) && this._isMultiproduct
    const optionsPhases = {
      main: 'Documents',
      financials: 'Financials'
    }
    const onChangeSet = ({ target }) => {
      const { value } = target
      return this.setState({ category: value })
    }
    const disabled = this._isDisabled()
    return (
      <>
        {isBusiness &&
          <select
            onChange={e => onChangeSet(e)}
            value={value}
            disabled={disabled}
          >
            {children}
          </select>
        }
        { showPhase &&
          <>
            {' '}
            <select
              onChange={e => this.setState({ phase: e.target.value })}
              value={phase}
            >
              {this.renderKeyOptions(optionsPhases)}
            </select>
          </>
        }
      </>
    )
  }
  renderConditionalFields = () => {
    const { categories } = this.props
    const { category, entityType } = this.state
    const isBusiness = entityType === 'Business'
    const isGuarantor = entityType === 'Guarantor'
    let title = isBusiness  ? 'Category' : ''
    if (this._isMultiproduct) {
      title = `${title}${category === this.financialCategory || isGuarantor ? `${isBusiness ? ' - ' : ''}Phase` : ''}`
    }
    const selectProps = {
      value: category,
      children: this.renderKeyOptions(categories),
      isBusiness,
      isGuarantor
    }
    return (
      <InputContainer>
        <Label>
          {title}
        </Label>
        {this.getSelectType(selectProps)}
      </InputContainer>
    )
  }
  changeEntity = async (e) => {
    const { value } = e.target
    const [entityType, rid] = value.split('-')

    try {
      await this.resetCategory(entityType)
      await this.setState({ entityType })
      await this.setCurrentEntity(entityType, rid)
    } catch (err) {
      console.log(err)
    }
  }
  resetCategory = type => {
    const [categoryFirst] = Object.keys(this.props.categories)
    const category = type === 'Business' ? categoryFirst : 'guarantor_default'
    this.setState({ category })
  }
  renderRadioLabel = (onChangeHash, checked, disabled, id, text) => {
    const radioProps = {
      checked,
      disabled,
      id,
      type: 'radio',
      onChange: () => this.setState(onChangeHash)
    }
    return (
      <RadioLabel>
        <RadioInput {...radioProps} />
        {text}
      </RadioLabel>
    )
  }
  renderEntitySelect = () => {
    const { document } = this.props
    const { files = [] } = document
    const { currentEntity, entityType } = this.state
    const { rid } = currentEntity

    return (
      <select
        value={`${entityType}-${rid}`}
        onChange={e => this.changeEntity(e)}
        disabled={this._isDisabled() || files.length > 0}
        id="entity_type_select"
      >
        {this._storeEntities().map(({ __typename, name, rid }) =>
          (<option key={`${__typename}-${name}-${rid}`}
            value={`${__typename}-${rid}`}
          >
            {name}
          </option>)
        )}
      </select>
    )
  }
  render() {
    const { toggleModal, newBucket, document } = this.props
    const { editable, instructions } = document
    const { title, description, adminOnly, isLoading, esignable } = this.state
    const isDisabled = this._isDisabled()
    const isEditable = !newBucket && !editable
    return (
      <Container id={`${newBucket ? 'new' : 'edit'}_bucket_modal`}>
        <Header>
          <Title>
            {`${newBucket ? 'New' : 'Edit'} Document Bucket`}
          </Title>
          <Close onClick={toggleModal}>X</Close>
        </Header>
        <Form>
          <InputContainer>
            <Label>
              Document Name
            </Label>
            <DocumentBucketAutocomplete
              value={title}
              onChange={({ target }) => this.setState({ title: target.value })}
              onSelect={this.onNameSelect}
              disabled={isDisabled}
            />
          </InputContainer>
          <InputContainer>
            <Label>
              Instructions to Borrower
            </Label>
            <TextArea
              defaultValue={description || instructions}
              onChange={({ target }) => this.setState({ description: target.value })}
              disabled={isDisabled}
              maxLength="255"
              id="instructions_text_area"
            />
          </InputContainer>
          <InputContainer>
            <Label>
              Where does this document go?
            </Label>
            {this.renderEntitySelect()}
          </InputContainer>
          {this.renderConditionalFields()}
          <InputContainer>
            <Label>
              Display this bucket on the borrower’s document upload page?
            </Label>
            <RadioButtonContainer>
              {this.renderRadioLabel({ adminOnly: false }, !adminOnly, isEditable, 'borrower_visible_yes', 'Yes')}
              {this.renderRadioLabel({ adminOnly: true }, adminOnly, isEditable, 'borrower_visible_no', 'No')}
            </RadioButtonContainer>
          </InputContainer>
          <InputContainer>
            <Label>
              Would you like to make this document available for E-Sign?
            </Label>
            <RadioButtonContainer>
              {this.renderRadioLabel({ esignable: true }, esignable, false, 'esign_yes', 'Yes')}
              {this.renderRadioLabel({ esignable: false }, !esignable, false, 'esign_no', 'No')}
            </RadioButtonContainer>
          </InputContainer>
          {!__updated_documents_experience_ui && this.renderFiles()}
          <hr />
          <SaveBucket loading={isLoading} onClick={this.onSave} id={`${newBucket ? 'create' : 'update'}_bucket`}>
            {`${newBucket ? 'Add' : 'Update'} Document Bucket`}
          </SaveBucket>
        </Form>
      </Container>
    )
  }
}

export { DocumentBucketModal }

export default compose(
  graphql(UpsertDocumentBucket, {
    name: 'upsertDocumentBucket'
  }),
  graphql(DestroyDocumentFiles, {
    name: 'destroyDocumentFiles'
  }),
  WithLoan
)(DocumentBucketModal)
